const INSTAGRAM_SHORTCODE_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const BIGINT_ZERO = BigInt(0);
const BIGINT_RADIX = BigInt(64);

const isInstagramPostUrl = (value: string): boolean => {
  const normalized = value.trim().toLowerCase();
  return (
    normalized.startsWith('https://www.instagram.com/')
    || normalized.startsWith('https://instagram.com/')
    || normalized.startsWith('http://www.instagram.com/')
    || normalized.startsWith('http://instagram.com/')
  );
};

const parseInstagramMediaPk = (mediaId?: string): bigint | null => {
  const pkPart = mediaId?.trim().split('_')[0] ?? '';
  if (pkPart.length < 10 || !/^\d+$/.test(pkPart)) {
    return null;
  }

  try {
    const pk = BigInt(pkPart);
    return pk > BIGINT_ZERO ? pk : null;
  } catch {
    return null;
  }
};

const encodeInstagramShortcode = (value: bigint): string => {
  let remaining = value;
  let shortcode = '';
  while (remaining > BIGINT_ZERO) {
    const remainder = Number(remaining % BIGINT_RADIX);
    remaining /= BIGINT_RADIX;
    shortcode = INSTAGRAM_SHORTCODE_ALPHABET[remainder] + shortcode;
  }
  return shortcode;
};

export const buildInstagramPermalink = (mediaId?: string, mediaProductType?: string): string | undefined => {
  const trimmed = mediaId?.trim();
  if (!trimmed) {
    return undefined;
  }

  if (isInstagramPostUrl(trimmed)) {
    return trimmed;
  }

  const pk = parseInstagramMediaPk(trimmed);
  if (pk == null) {
    return undefined;
  }

  const shortcode = encodeInstagramShortcode(pk);
  if (!shortcode) {
    return undefined;
  }

  const productType = mediaProductType?.trim().toUpperCase();
  const path = productType === 'REELS' || productType === 'REEL' ? 'reel' : 'p';
  return `https://www.instagram.com/${path}/${shortcode}/`;
};

export const resolveInstagramPreviewPermalink = (preview: {
  permalink?: string;
  externalContentId?: string;
  mediaProductType?: string;
}): string | undefined => {
  const existing = preview.permalink?.trim();
  if (existing) {
    return existing;
  }

  return buildInstagramPermalink(preview.externalContentId, preview.mediaProductType);
};
